import React, { useState } from 'react';
import styled from '@emotion/styled';
// eslint-disable-next-line import/no-duplicates
import ImpressionsHandler from '@nykaa/deals-utils/impressions';
// eslint-disable-next-line import/no-duplicates
import ClickHandler from '@nykaa/deals-utils/clicks';
import useIntersectCallback from '@nykaa/utils/IObserver/useIntersectCallback';
import useIntersectOutCallback from '@nykaa/utils/IObserver/userIntersectOutCallback';
import { handleRightClickCallback } from '../../helper';
import { isVideoType, } from './helpers';
import { VIEWABLE_THRESHOLD } from '../../constants';
import Iframe from '../Iframe';
const Wrapper = styled.div `
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  border-radius: 3px;
  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.22);
  width: 100%;
`;
const displayIframe = (url) => (React.createElement(Iframe, { title: `${url}`, width: "100%", height: "100%", src: url, frameBorder: "0", allowFullScreen: true }));
const CarouselChild = (widgetData) => {
    const [isIframe, setIframe] = useState(false);
    const { params, children, trackingData, isDesktop, isDevModeEnabled, devModeData, rootMargin, } = widgetData;
    const [setNodeToObserve] = useIntersectCallback({ rootMargin }, () => ImpressionsHandler.handleImpression(trackingData));
    const [setNodeToObserveOut] = useIntersectOutCallback({}, VIEWABLE_THRESHOLD, () => ImpressionsHandler.handleImpressionV2(trackingData), () => ImpressionsHandler.removeImpression(trackingData));
    const { appLinkData, appLinkType, trackingParams, url, actionType, } = params;
    const clickHandler = (event) => {
        event.preventDefault();
        if (!isVideoType(actionType)) {
            ImpressionsHandler.handleClick(trackingData)
                .finally(() => {
                /**
                 * ? Why finally?
                 * even in case of an error in handling impression...
                 * we would want the click to function as expected
                 */
                ClickHandler.handleClick({
                    appLinkData,
                    appLinkType,
                    trackingParams,
                    webActionType: actionType,
                    webActionUrl: url,
                    isDesktop,
                });
            });
        }
        else {
            setIframe(true);
        }
    };
    const devModeHandler = (!!isDevModeEnabled && {
        onContextMenu: () => handleRightClickCallback(devModeData),
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Wrapper, Object.assign({ onClick: clickHandler, ref: setNodeToObserve }, devModeHandler),
            React.createElement("div", { ref: setNodeToObserveOut },
                isIframe && (displayIframe(url)),
                (!isIframe) && (children)))));
};
export default CarouselChild;
